<template>
    <div></div>
</template>
<script>
import {onMounted} from 'vue'
import {useRoute,useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { Toast } from 'vant'
import {wxGetOpenid } from  '@/api/pay'

const CODE_USED_PREFIX = 'wx_oauth_code_used:'
const CODE_EXCHANGING_KEY = 'wx_oauth_exchanging'

function parsePayPage(p) {
    if (!p) return null
    try {
        return typeof p === 'string' ? JSON.parse(p) : p
    } catch (e) {
        return null
    }
}

function goBackToPay(router, payPage, { canPay } = {}) {
    if (payPage && payPage.name) {
        const query = { ...(payPage.query || {}) }
        if (canPay) {
            query.canPay = 1
        } else {
            delete query.canPay
        }
        router.replace({
            name: payPage.name,
            query,
        })
        return
    }
    router.replace({ path: '/' })
}

function isCodeUsedError(error) {
    const parts = [
        error?.message,
        error?.response?.data?.message,
        error?.response?.data?.msg,
        error?.response?.data?.error,
    ]
    try {
        parts.push(JSON.stringify(error?.response?.data || {}))
    } catch (e) {
        // ignore
    }
    return /40163|code been used/i.test(parts.filter(Boolean).join(' '))
}

export default {
    name:'GetAuthUrl',
     setup() {
         const route = useRoute()
         const router = useRouter()
         const store = useStore()

        onMounted(async () => {
            const code = route.query.code
            const p = route.query.p
            const payPage = parsePayPage(p)

            // 读出 code 后立刻清掉 URL，避免刷新/回退再次用同一 code 兑换
            await router.replace({
                path: '/getAuthUrl',
                query: p ? { p } : {},
            })

            if (!code) {
                Toast('授权信息缺失，请重新发起支付')
                goBackToPay(router, payPage)
                return
            }

            const usedKey = CODE_USED_PREFIX + code
            if (sessionStorage.getItem(usedKey)) {
                Toast('授权已失效，请重新发起支付')
                goBackToPay(router, payPage)
                return
            }
            if (sessionStorage.getItem(CODE_EXCHANGING_KEY) === code) {
                // 同一 code 正在兑换中（防重入），不再二次请求
                return
            }

            sessionStorage.setItem(CODE_EXCHANGING_KEY, code)
            try {
                const openId = await wxGetOpenid({ code })
                sessionStorage.setItem(usedKey, '1')
                // 兼容接口直接返回 openid 字符串，或包在 data 字段中
                store.commit('setOpenId', openId && openId.data != null ? openId.data : openId)
                goBackToPay(router, payPage, { canPay: true })
            } catch (error) {
                sessionStorage.setItem(usedKey, '1')
                const tip = isCodeUsedError(error)
                    ? '授权已失效，请重新发起支付'
                    : '获取微信授权失败，请重新发起支付'
                Toast(tip)
                // 失败不带 canPay，回到支付页后由用户再次点击支付，重新走 oauth2-authorize
                goBackToPay(router, payPage)
            } finally {
                sessionStorage.removeItem(CODE_EXCHANGING_KEY)
            }
        })
        return {
            
        };
    },
}
</script>
